import { Star } from "lucide-react";

export default function Stars({ value = 0, size = 14, showEmpty = true, className = "" }) {
  const rating = Math.max(0, Math.min(5, Number(value) || 0));
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${rating.toFixed(1)} out of 5`}>
      {[0, 1, 2, 3, 4].map((i) => {
        const fill = Math.max(0, Math.min(1, rating - i));
        return (
          <span key={i} className="relative inline-block" style={{ width: size, height: size }}>
            {showEmpty && (
              <Star className="absolute inset-0 text-zinc-200" style={{ width: size, height: size }} />
            )}
            <span className="absolute inset-0 overflow-hidden" style={{ width: `${fill * 100}%` }}>
              <Star className="text-brand fill-current" style={{ width: size, height: size }} />
            </span>
          </span>
        );
      })}
    </div>
  );
}
